import React, { useEffect, useState } from "react";
import { api } from "../api";
import { Card } from "./ui/card";
import { Badge } from "./ui/badge";
import { Mail, MessageSquare, Share2, UserPlus, CheckCircle2, Clock } from "lucide-react";

const ChannelIcon = ({ c }) => c === "email" ? <Mail className="h-3.5 w-3.5" /> : c === "sms" ? <MessageSquare className="h-3.5 w-3.5" /> : <Share2 className="h-3.5 w-3.5" />;

export const InvitesPanel = ({ t }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/invites").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  const accepted = (rows || []).filter((r) => r.status === "accepted").length;
  return (
    <Card className="p-4 space-y-3" data-testid="invites-panel">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <UserPlus className="h-5 w-5 text-primary" />
          <div>
            <div className="text-sm font-semibold">{t("invites_title")}</div>
            <div className="text-[11px] text-muted-foreground" data-testid="invites-summary">
              {rows ? `${rows.length} ${t("invites_sent")} · ${accepted} ${t("invites_accepted")}` : "…"}
            </div>
          </div>
        </div>
      </div>
      {rows && rows.length === 0 && <div className="text-xs text-muted-foreground" data-testid="invites-empty">{t("invites_empty")}</div>}
      {rows && rows.length > 0 && (
        <div className="space-y-1.5 max-h-80 overflow-y-auto pr-1">
          {rows.map((r) => (
            <div key={r.id} className="flex items-start gap-2 rounded-lg border px-2.5 py-2" data-testid={`invite-row-${r.id}`}>
              <span className="mt-0.5 text-muted-foreground"><ChannelIcon c={r.channel} /></span>
              <div className="min-w-0 flex-1">
                <div className="text-xs font-medium break-all">{r.to}</div>
                <div className="text-[11px] text-muted-foreground">
                  {t("invited_by")} {r.inviter_name || "?"}{r.company_name ? ` · ${r.company_name}` : ""} · {new Date(r.created_at).toLocaleDateString()}
                </div>
              </div>
              {r.status === "accepted"
                ? <Badge className="bg-emerald-600 text-white text-[10px] gap-1"><CheckCircle2 className="h-3 w-3" />{t("invite_status_accepted")}{r.accepted_name ? ` · ${r.accepted_name}` : ""}</Badge>
                : <Badge variant="outline" className="text-[10px] gap-1"><Clock className="h-3 w-3" />{t("invite_status_pending")}</Badge>}
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
